import { render, staticRenderFns } from "./ClientAddcomment.vue?vue&type=template&id=c86c4980&scoped=true&"
import script from "./ClientAddcomment.vue?vue&type=script&lang=js&"
export * from "./ClientAddcomment.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddcomment.vue?vue&type=style&index=0&id=c86c4980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86c4980",
  null
  
)

export default component.exports